import Model from '../Model';
import Mithril from 'mithril';
import WikiLabelOptions from './WikiLabelOptions';


export default class WikiLabel extends Model {
  tagId() {
    return Model.attribute<number>('tagId').call(this);
  }
  icon() {
    return Model.attribute<string>('icon').call(this);
  }
  name() {
    return Model.attribute<string>('name').call(this);
  }
  sortCount() {
    return Model.attribute<number>('sortCount').call(this);
  }
  status() {
    return Model.attribute<boolean>('status').call(this);
  }
  wikiLabelOptions() {
    return Model.hasMany<WikiLabelOptions>('wikiLabelOptions').call(this);
  }

}
